"use strict";

var _interopRequireDefault = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.salesReportWithNotesSubMenu = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
const salesReportWithNotesSubMenu = exports.salesReportWithNotesSubMenu = [{
  path: '/report/sales-report-with-notes',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/report/sales-report-with-notes/list.vue'))),
  name: 'report.salesReportWithNotes',
  meta: {
    title: 'report.salesReportWithNotes.title',
    roles: ['Super Admin', 'Admin', 'Read Only', 'Account Manager'],
    noCache: true,
    hidden: false,
    icon: 'documentation'
  }
}];